import React from 'react';

const Footer = () => {
    return (
        <div className="footer text-center py-4" style={{backgroundColor:"#8147f5", color:"#ffffff"}}>
            <p>Copyright 2020 All Right Reserved By siddika.tas28@gmail.com </p>
        </div>
    );
};

export default Footer